import { ReportServices } from "../../services/reports/reports";

export const getReports = async (page, itemsPerPage, category, status, trackId) => {
    try {
        return await ReportServices.getReports(page, itemsPerPage, category, status, trackId);
    } catch (error) {
        console.log(error);
        return error.message;
    }
};

export const getReportPartials = async () => {
    try {
        return await ReportServices.getReportPartials();
    } catch (error) {
        console.log(error);
        return error.message;
    }
};

export const searchReportUsers = async (q, limit) => {
    try {
        return await ReportServices.searchUsers(q, limit);
    } catch (error) {
        console.log(error);
        return error.message;
    }
};

export const createReport = async (data) => {
    try {
        return await ReportServices.createReport(data);
    } catch (error) {
        console.log(error);
        return error.message;
    }
};

export const getReportDetails = async (trackId) => {
    try {
        return await ReportServices.getReportDetails(trackId);
    } catch (error) {
        console.log(error);
        return error.message;
    }
};
